<template>
	<div style="padding-bottom: 2.5rem;" ref="container">

		<div >

		<van-list
				v-model="loading"
				:finished="finished"
				finished-text="暂无更多"
				@load="onLoad"
				offset = '50'
			>
			<div v-for="(item,index) in list" :key="index" class="arrListy" ref="inner">
				<div class="top">
					<div class="username">
						{{item.consignee}} {{item.phone_mob}}<div v-if='item.default == 1 && !selectCity' class="badge">默认</div>
					</div>
					<div class="gray">{{item.region_name}}{{item.address}}</div>
				</div>
				<div class="flex_b bottom">
					<div class="flex" @click="editAddr(item)">
						<iconfont name="icondui" :color="selectCity ? item.addr_id == cityId ? 'red' : '#999999' :  item.default == 1 ?'red':'#999999'" size=".7rem" class="icon"></iconfont>
						{{selectCity ? '选择此地址' : '设为默认'}}
					</div>
					<iconfont  @click="jump(item.addr_id)" name="iconbianji4" color="#999999"  class="icon myedit"></iconfont>
				</div>
			</div>
		</van-list>
		<div  class="nonData" v-if="list.length==0" >
			<img class="shop_qs"  src="http://statics.7dingdong.com/static/wx_program_img/integral_mall/quexngye.png" />
			<div class="znw">暂时还没有地址</div>
		</div>
		</div>
		<div  v-if='selectCity && list.length !=0 ' class="flex_b my_btn_box">
			<div class="my_btn selectAddres" @click="jump('add')">添加地址</div>
			<div class=" my_btn" @click="jump">选择地址</div>
		</div>
	
		<div class="footerBottom" v-else  @click="jump('add')"> 新增地址</div>
	

	</div>
</template>
<script>
	import { Toast } from 'vant';
	import {sendRequest} from '@/assets/public'
	import Iconfont from "@/components/iconfont.vue";
	//
	export default {
		components: {Iconfont},
		data() {
			return {
				selectCity: false,  // 是否是在详情进入
				cityId: '',
				chosenAddressId: '1',
				list:[],
				page:1,
				isLoading:false,
				id: null,
				loading: false,
				finished: false,
			}
		},
		async created () {
			this.cityId = this.$route.query.addr_id?this.$route.query.addr_id :'';

			if(this.$route.query.isDetails &&  this.$route.query.id){
				
				window.localStorage.setItem('goodsId',this.$route.query.id)
				this.selectCity = true;
				this.id = this.$route.query.id || this.$route.params.id;
				this.cityId = this.$route.query.addr_id
			}

			if(!this.$route.query.isDetails){
				localStorage.removeItem('goodsId')
			}
			
			this.Datalist()
		},
		mounted () {
			window.scrollTo(0,0);
		},

		methods: {
			onLoad(){
				this.page++;
				if(this.list.length >=9 ){
					this.Datalist();
				}
			},
			jump(contents){
				let contentsType = (typeof contents == 'number') ;		
				if(contents == 'add'|| contentsType){ //新增和编辑跳转 增加页面
					this.$router.push({
						name: 'addressAddto',
						query: {
							editId: (typeof contents == 'number') ? contents : false,
							modification:(typeof contents == 'number')? 'modify' : 'add',
							addr_id:this.cityId							
						}
					})
					return
				}			
				this.$router.replace({
					name: 'shopDetail',
					query: {
						addr_id:this.cityId,
						id: this.id						
					},
				});
			},
			async Datalist(){
				this.loading = true;
				let {status,msg,content} = await  sendRequest('user/addrList',{
					page:this.page,

				})
				Toast.clear();
				let tlist= content.data|| [];
				this.list = this.list.concat(tlist);
				this.finished = tlist.length == 0  || tlist.length <8;

				this.loading = false;
				this.isloading = false;
			},
			async editAddr(cityInfo) {
			
				let _this= this;

				if(this.selectCity){
				
					this.cityId = cityInfo.addr_id
					return;
				}
				this.isLoading=true
				cityInfo.default=1
				cityInfo.is_show=1
				cityInfo.set_default=1
				
				let res = await sendRequest('user/editAddr', cityInfo)
				Toast.loading({
					message: '加载中...',
					forbidClick: true
				});
				this.page=1
				setTimeout(()=>{

					this.list=[]
					this.isLoading=false
					this.Datalist()
				},500)

			},
			onAdd() {
				Toast('新增地址');
			},
			onEdit(item, index) {
				Toast('编辑地址:' + index);
			}
		}
	}
</script>

<style scoped>
	.my_btn_box{
		padding-top: 0.4rem;
		padding-left: 0.6rem;
		padding-right: 0.6rem;
		padding-bottom: 0.8rem;
		position: fixed;
		bottom: 0;
		background: #f6f5f8;
	}
	.my_btn{
		width:6.5rem;
		height: 1.9rem;
		line-height: 2rem;
		background: rgba(253,62,62,1);
		color: #fff;
		text-align: center;
		border-radius: 0.2rem;
		font-size: 0.6rem;
		border: 0.04rem solid transparent;
		
	}
	.selectAddres{	
		background: #f6f5f8;
		border: 0.04rem solid rgba(253,62,62,1);
		color:rgba(253,62,62,1);
		margin-right: 0.6rem;
	}
	.arrListy{
		background: #fff;
		margin-top: 0.4rem;
		padding-left: 0.8rem;
	}
	.top{
		border-bottom: 1px solid #DDDDDD
	}
	.username{
		padding: 0.8rem 0.8rem 0.4rem 0;
		font-size: 0.56rem;
	}

	.badge{
		width:1.36rem;
		height:0.72rem;
		background:rgba(253,62,62,1);
		border-radius:0.04rem;
		font-size: 0.48rem;
		color: #fff;
		display: inline-block;
		text-align: center;
		line-height: 0.72rem;
	}
	.gray{
		font-size: 0.48rem;
		padding: 0 0.8rem 0.8rem 0
	}
	.bottom{
		padding: 0.6rem 0.8rem 0.6rem 0;
		font-size: 0.56rem;
		font-weight: 500
	}
	.flex_b {
		display: flex;
		justify-content: space-between;
		box-sizing: border-box;
	}
	.flex {
		display: flex;
	}
	.myedit.x-icon{
		font-size: .4rem !important;
	}
	.icon{margin-right: 0.2rem;}
	.footerBottom{width: 100%;position: fixed;bottom: 0;height: 2rem;background:rgba(253,62,62,1);text-align: center;line-height: 2rem;color: #fff;font-size: 0.6rem;font-weight:500;=color:rgba(255,255,255,1);}
	/* 暂无地址 */
	.nonData{
		position: fixed;
		width: 100vw;
		height: 100vh;
		left: 0;
		top: 0;
		background: #fff;
	}
	.nonData image{
		width: 10.5rem;
		height: 7.52rem;
		display: block;
		margin: 3.6rem auto 0
	}
	.znw{
		font-size:0.56rem;
		font-family:PingFang SC;
		font-weight:500;
		color:rgba(153,153,153,1);
		line-height:0.84rem;
		text-align: center;
	}
	.shop_qs{
		width: 10.5rem;
		height: 7.52rem;
		display: block;
		margin: 0 auto;
	}
	.contents{position: fixed;z-index: 99;left: 50%;top: 50%;transform: translate(-50%,-50%);}
</style>
